var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-content" }, [
      this.data.product_image.length > 0
        ? _c("img", {
            class: "img-fluid product-image",
            attrs: { src: this.data.product_image[0].url },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: " mt-1 ml-1 mr-1 mb-05" }, [
        _c("span", { staticClass: "h3" }, [
          _c("a", {
            staticClass: "text-dark",
            attrs: { href: "/product/" + this.data.slug },
            domProps: { textContent: _vm._s(this.data.title) },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.average_rating !== null
        ? _c("div", { staticClass: "mt-05 ml-1 mr-1 mb-05" }, [
            _c("span", {
              class: "rating-static rating-" + _vm.average_rating * 10,
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [{ name: "linkified", rawName: "v-linkified" }],
        staticClass: "ml-1 mr-1 mt-1 mb-0 pb-1 breakAll postarea image-resize",
        domProps: { innerHTML: _vm._s(this.data.product_description) },
      }),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            staticClass: "font-small-3 ml-1",
            attrs: { href: "/product/" + this.data.slug },
          },
          [
            _vm._v(_vm._s(_vm.__("globals.read_more")) + " "),
            _c("i", { staticClass: "feather icon-chevron-right" }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-05 border-bottom text-right" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex pl-05 pr-05 pt-0 pb-05 justify-content-between align-items-center ",
        },
        [
          this.data.product_price !== 0 && this.data.product_price !== null
            ? _c("div", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm._f("currency")(this.data.product_price, _vm.site_tax)
                    ) +
                    "\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ml-auto" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-sm btn-flat-primary text-bold-700 ",
                attrs: { href: "/product/" + this.data.slug },
              },
              [
                _vm._v(
                  "View\n                        " +
                    _vm._s(_vm.__("globals.view_product")) +
                    " "
                ),
                _c("i", { staticClass: "feather icon-chevron-right" }),
              ]
            ),
            _vm._v(" "),
            this.data.external_link !== null
              ? _c("a", { attrs: { href: "/product/" + this.data.slug } }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm btn-primary waves-effect waves-light",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__("globals.more_info")) +
                          " "
                      ),
                      _c("i", { staticClass: "feather icon-chevron-right" }),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }